import { 
	CHANGE_SEARCH_FIELD,
	REQUEST_ROBOTS_PENDING,
	REQUEST_ROBOTS_SUCCESS,
	REQUEST_ROBOTS_FAILED
} from "./constants.js";


export const setSearchField = (text) => ({
	type: CHANGE_SEARCH_FIELD,
	payload: text
})
// this will take text input and return an object with change search field
// and send the data, which is text 

export const requestRobots = () => (dispatch) => {
	dispatch({type: REQUEST_ROBOTS_PENDING});
	fetch('https://jsonplaceholder.typicode.com/users')
      .then(response=> response.json())
      .then(data => dispatch({ type: REQUEST_ROBOTS_SUCCESS, payload: data}))
      .catch(error => dispatch({type: REQUEST_ROBOTS_FAILED, payload: error}))
}


// WEBPACK FOOTER //
// ./src/actions.js